import React from 'react'
import classNames from 'classnames'
import { format, addDays } from 'date-fns'
import Button from '@everlane/button'

function PurchaseButton({
  className,
  onClick,
  onMouseEnter,
  onMouseLeave,
  orderableState,
  isLoading,
  selectedVariant,
  defaultText = 'Add To Bag',
}) {
  const preOrderableText =
    orderableState === 'preorderable' && !!selectedVariant?.restock_date
      ? `Pre-Order (Ships ${format(new Date(selectedVariant.restock_date), 'MMM d')} - ${format(
          addDays(new Date(selectedVariant.restock_date), 7),
          'MMM d',
        )})`
      : defaultText
  const buttonText =
    {
      shippable: isLoading ? 'Adding…' : defaultText,
      waitlistable: 'Waitlist',
      waitlisted: 'Waitlisted',
      preorderable: preOrderableText,
      sold_out: 'Sold Out',
    }[orderableState] || defaultText

  const isDisabled = isLoading || ['sold_out', 'waitlisted'].includes(orderableState)

  const buttonClass = classNames('product-page__purchase-button', className, {
    'product-page__purchase-button--loading': isLoading,
  })

  return (
    <div className="product-page__purchase-button-container">
      <Button
        dark
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        className={buttonClass}
        disabled={isDisabled}
        variant="rectangle"
      >
        {buttonText}
      </Button>
    </div>
  )
}

export default PurchaseButton
